import { render, staticRenderFns } from "./orderExtras.vue?vue&type=template&id=32fbfc28&"
import script from "./orderExtras.vue?vue&type=script&lang=js&"
export * from "./orderExtras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports